var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var CheckSingleIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M23.8480919,5.08675665 L20.8806837,2.15386553 C20.7809861,2.0553605 20.6456157,2 20.5044435,2 C20.3632713,2 20.2279009,2.0553605 20.1282034,2.15386553 L7.59536749,14.5139067 C7.49566994,14.6124117 7.3602995,14.6677722 7.21912733,14.6677722 C7.07795516,14.6677722 6.94258472,14.6124117 6.84288718,14.5139067 L3.87547896,11.5810156 C3.77578141,11.4825105 3.64041097,11.42715 3.4992388,11.42715 C3.35806663,11.42715 3.22269619,11.4825105 3.12299865,11.5810156 L0.155590424,14.5139067 C-0.0518634748,14.7184234 -0.0518634748,15.049945 0.155590424,15.2544617 L6.84288718,21.8461345 C6.94258472,21.9446395 7.07795516,22 7.21912733,22 C7.3602995,22 7.49566994,21.9446395 7.59536749,21.8461345 L23.8480919,5.81997943 C24.050636,5.6163302 24.050636,5.29040587 23.8480919,5.08675665 Z" })))); };
export var CheckSingle = styled(CheckSingleIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=CheckSingle.js.map